import {
    MAX_FOLDER_PANE_WIDTH,
    MAX_LIST_VIEW_WIDTH,
    MIN_LIST_VIEW_WIDTH,
    MIN_READING_PANE_WIDTH,
} from '../internalConstants';
import { LEFT_RAIL_STATIC_WIDTH } from '../mailLayoutConstants';
import { BrowserWidthBucket, getBrowserWidthBucket } from 'owa-layout';
import { getBrowserWidth } from 'owa-config';
import { shouldShowFolderPane } from '../selectors/shouldShowFolderPane';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Gets the left nav max width for the current browser window width
 */
export function getLeftNavMaxWidth(): number {
    const browserWidthBucket = getBrowserWidthBucket();

    if (browserWidthBucket <= BrowserWidthBucket.From919_To999) {
        return 198;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1080_To1199) {
        return 236;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1366_To1399) {
        return 254;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1400_To1599) {
        return 300;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1600_Above) {
        return 320;
    }
    return MAX_FOLDER_PANE_WIDTH;
}

/**
 * Gets the compact list view max width for the current browser window width
 */
export function getCompactListViewMaxWidth(): number {
    const browserWidthBucket = getBrowserWidthBucket();

    if (browserWidthBucket <= BrowserWidthBucket.From919_To999) {
        return 350;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1080_To1199) {
        return 380;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1366_To1399) {
        return 452;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1400_To1599) {
        return 540;
    }
    if (browserWidthBucket <= BrowserWidthBucket.From1600_Above) {
        return 574;
    }
    return MAX_LIST_VIEW_WIDTH;
}

/**
 * Gets the list view max width for the current browser window width
 */
export function getListViewMaxWidth(): number {
    // Allow a wider List View when using SLV with right RP
    if (isFeatureEnabled('mon-tri-slvWithRightReadingPane')) {
        return Math.max(
            MIN_LIST_VIEW_WIDTH,
            getBrowserWidth(true /* skipCache */) -
                (shouldShowFolderPane() ? getLeftNavMaxWidth() : 0) -
                MIN_READING_PANE_WIDTH -
                LEFT_RAIL_STATIC_WIDTH
        );
    }

    return getCompactListViewMaxWidth();
}
